import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { TelemedicineServicesBanner } from "../images";

export const TelemedicineServices = () => {
    const { t } = useTranslation();
    const keyFeatures = t('telemedicineServices.keyFeatures', { returnObjects: true }) as string[]

    return (
        <div>
            <PageBanner image={TelemedicineServicesBanner} title={t('telemedicineServices.bannerTitle')} />

            <ContentPanel headerText={t('telemedicineServices.header')}>
                <h4 className="text-xl mb-5">{t('generic.keyFeatures')}</h4>

                <UnorderedList items={keyFeatures} />

                <h4 className="text-xl my-5">{t('generic.industriesServed')}</h4>
                <span className="text-white leading-relaxed">{t('telemedicineServices.industriesServed')}</span>
            </ContentPanel>
        </div>
    )
}